import * as React from "react";
import { cn, surahNameGlyph, surahsNamesMap } from "@/lib/utils";

interface SurahNameProps {
	number: number;
	/** Accessible Arabic name; defaults to the transliteration. */
	nameArabic?: string;
	className?: string;
}

/** Calligraphic surah name (1405H Madinah style) with an accessible text twin. */
const SurahName: React.FC<SurahNameProps> = ({ number, nameArabic, className }) => (
	<>
		<span
			aria-hidden
			translate="no"
			// leading-none goes last: tailwind-merge drops line-height when a
			// font-size class follows it.
			className={cn("select-none font-surah text-emerald-900", className, "leading-none")}
		>
			{surahNameGlyph(number)}
		</span>
		<span className="sr-only" lang={nameArabic ? "ar" : undefined}>
			{nameArabic ?? surahsNamesMap.get(number)}
		</span>
	</>
);

export default React.memo(SurahName);
